'use strict';
require('../../modules/esnext.uint8-array.to-hex');
